import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=3cb9c3a0"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports